var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMenuEclipseClose(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Elipse_9",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff3838",
    floodOpacity: 0.2
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_39",
    "data-name": "Grupo 39",
    transform: "translate(-348 -16)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 348, 16)",
    filter: "url(#Elipse_9)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_9-2",
    "data-name": "Elipse 9",
    cx: 23,
    cy: 23,
    r: 23,
    transform: "translate(9 6)",
    fill: "#ff3838"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1",
    transform: "translate(367.147 45.881) rotate(-45)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_35",
    "data-name": "Trazado 35",
    d: "M13.931,10.412H10.8c-.3,0-.3,0-.3.3,0,1.979,0,3.959-.007,5.938a2.15,2.15,0,0,1-.143.748,1.108,1.108,0,0,1-.588.594,1.427,1.427,0,0,1-1.567-.172,1.122,1.122,0,0,1-.447-.906q0-3.047,0-6.092c0-.061,0-.122-.009-.181-.018-.19-.044-.218-.24-.227-.159-.008-.318-.006-.477-.006-1.922,0-3.844,0-5.766,0A1.2,1.2,0,0,1,.344,10,1.29,1.29,0,0,1,0,9.052,1.477,1.477,0,0,1,.418,8.07a1.233,1.233,0,0,1,.907-.37c1.225-.009,2.45,0,3.676,0l2.456,0c.028,0,.056,0,.084,0,.127,0,.2-.042.2-.184s.007-.28.007-.42c0-1.956.006-3.911,0-5.868A1.316,1.316,0,0,1,8.818.02,1.632,1.632,0,0,1,9.858.2a1.291,1.291,0,0,1,.64,1.159c.008,1.564,0,3.128,0,4.692v1.47c0,.178,0,.179.18.179,2.039,0,4.078,0,6.117,0a1.793,1.793,0,0,1,.534.086,1.215,1.215,0,0,1,.824.937,1.351,1.351,0,0,1-.185,1.123,1.138,1.138,0,0,1-1.036.574c-1-.02-2-.006-3-.006h0Z",
    transform: "translate(0.002 -0.006)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuEclipseClose);
export default __webpack_public_path__ + "static/media/menu-eclipse-close.e6b1e03bdab98592d874864779b9c599.svg";
export { ForwardRef as ReactComponent };